<template>
	<div class="col flex-column flex-grow">
		<slot></slot>
	</div>
</template>

<script>
	export default {
	}
</script>

<style lang="stylus" scoped>
	.col {
		> .row:nth-child(n+2) {
			margin-top: .2rem;
		}

		> .module-box:nth-child(n+2) {
			margin-top: .2rem;
		}
	}
</style>
